import { render, staticRenderFns } from "./FlashNewsCreateView.vue?vue&type=template&id=23914637&"
import script from "./FlashNewsCreateView.vue?vue&type=script&lang=ts&"
export * from "./FlashNewsCreateView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports